<button [attr.data-is-active]="isActive()" [class.active]="isActive()">
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    @if(isActive()) {
    <use [attr.xlink:href]="SvgSpriteIcon.Bell"></use>
    } @else {
    <use [attr.xlink:href]="SvgSpriteIcon.BellLine"></use>
    }
  </svg>
</button>

<span>
  Notifications alert
</span>
